import React from "react";
import PropTypes from "prop-types";
import styles from "./Skills.css";
import Skill from "./Skill/Skill";

const Skills = ({ skills }) => {
  const skillItems = skills.map(({ name, rating }) => (
    <Skill title={name} rating={rating} />
  ));

  return (
    <div className={styles.Skills}>
      <div className={styles.SkillsHeader}>
        <h2>Skills</h2>
      </div>
      {skillItems}
    </div>
  );
};

Skills.propTypes = {
  skills: PropTypes.instanceOf(Array).isRequired
};

export default Skills;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/Resume/Skills/Skills.js